import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class StatisticSummaryFilterEntity {
  beginDate?: Date
  finalDate?: Date
  branch?: BranchMiniEntity
  service?: ServiceMiniEntity
  region?: RegionMiniEntity
}
